export const ENROLLED= "ENROLLED"
export const WAITLISTED= "WAITLISTED"
export const INVITED= "INVITED"
export const NOT_INVITED= "NOT_INVITED"
export const ELIGIBLE = "ELIGIBLE"
export const AVAILABLE = "AVAILABLE"
export const PAST = "PAST"
export const TESTINGINPROGRESS = "Testing in-progress"